import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { useAmplitude } from 'hooks/useAmplitude';
import { TApplication } from 'lendingApi/applications.types';
import _ from 'lodash';
import { PATH_NAMES } from 'utils/routes/pathNames';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';

export const useApplicationStatusCell = () => {
  const { trackEvent } = useAmplitude();
  const { checkIntroducerPermission } = useIntroducerData();
  const cannotInteractWithOffers = !checkIntroducerPermission(
    'can_interact_with_offers',
  );

  const cannotUploadDocuments = !checkIntroducerPermission(
    'can_upload_broker_documents',
  );

  const cannotRefreshOffers = !checkIntroducerPermission('can_refresh_offers');

  const cannotCreateApplications = !checkIntroducerPermission(
    'can_create_applications',
  );

  const getApplicationPath = (applicationId: string) =>
    PATH_NAMES.application({
      applicationId,
    });

  const getDocumentsPath = (applicationId: string) =>
    PATH_NAMES.applicationDocuments({
      applicationId,
    });

  const handleClick = (e: React.MouseEvent, status: TApplication['status']) => {
    e.stopPropagation();
    trackEvent(AMPLITUDE_EVENTS.dashboardCTAClicked, {
      Status: _.capitalize(_.startCase(status)),
    });
  };

  return {
    cannotRefreshOffers,
    cannotUploadDocuments,
    cannotCreateApplications,
    cannotInteractWithOffers,
    getApplicationPath,
    getDocumentsPath,
    handleClick,
  };
};
